// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__3cVv6","table-head":"Table_table-head__1BNuM","table-body":"Table_table-body__1cadH"};